module.exports = __webpack_public_path__ + "media/bootstrap-icons/bookmark-e4011a71.svg";